<template>
  <div>
    <Modal :title="formData.id ? '编辑' : '新增'" v-model="visible" width="800" class="my-modal" :mask-closable="false">
      <loading :isShow="loading" />
      <Form ref="form" :model="formData" class="page-form less" :label-width="80" v-if="visible">
        <FormItem label="所属机构">
          <Input type="text" v-model="formData.orgName" disabled placeholder="根据业务员回显"></Input>
        </FormItem>
        <FormItem label="所属团队">
          <Input type="text" v-model="formData.groupName" disabled placeholder="根据业务员回显"></Input>
        </FormItem>
        <FormItem prop="userId" label="业务员" :rules="$units.formRule.required('请输入')">
          <lzSelect
            v-model="formData.userId"
            placeholder="请输入姓名或工号搜索"
            ref="salesmanSelect"
            :remote-method="getUserList"
            :transfer="true"
            :disabled="!!formData.id || type == 'userAdd'"
            @change="selectSalesMan"
          >
            <template slot-scope="{ list }">
              <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.staffNo ? item.name + '-' + item.staffNo : item.name">
                <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </template>
          </lzSelect>
        </FormItem>
        <FormItem prop="staffType" label="工号类型" :rules="$units.formRule.required('请选择')">
          <RadioGroup v-model="formData.staffType" @on-change="staffTypeChange">
            <Radio label="1" :disabled="type != 'userAdd'">保险公司</Radio>
            <Radio label="2" :disabled="type != 'userAdd'">合作通道</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="insuranceId" label="上号公司" :rules="$units.formRule.required('请选择')">
          <Cascader
            :data="companyData"
            v-model="formData.insuranceId2"
            @on-change="cascaderChange(arguments[1])"
            change-on-select
            clearable
            filterable
            transfer
            :disabled="type != 'userAdd'"
            transfer-class-name="big"
          ></Cascader>
        </FormItem>
        <FormItem prop="staffNo" label="工号" :rules="$units.formRule.required('请输入')">
          <Input type="text" v-model.trim="formData.staffNo" placeholder="请输入" clearable></Input>
        </FormItem>
        <FormItem prop="extParam" label="扩展字段" class="full" v-if="hasMgaProduct == '1'">
          <Input type="textarea" v-model.trim="formData.extParam" :autosize="{ minRows: 2 }" placeholder="请输入" clearable></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzSelect from '@/components/commons/lzSelect';
export default {
  mixins: [common],
  components: { lzSelect },
  props: {
    hasMgaProduct: null,
    searchObj: {
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      type: '',
      visible: false,
      loading: false,
      companyData: [], //保司 树形数据
      companyList: [], //保司 list数据
      formData: {}
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    open(data, type) {
      this.type = type;// 默认空，业务员管理新增时:userAdd
      if (JSON.stringify(data) == '{}') {
        this.formData = {
          staffType: this.searchObj.supplierType || '1',
          insuranceId: this.searchObj.supplierId
        };
      } else {
        this.formData = JSON.parse(JSON.stringify(data));
      }
      this.visible = true;
      this.getChannel();
    },
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        this.$http({
          url: formData.id ? '/buz/userStaff/edit':'/buz/userStaff/add',
          type: 'post',
          data: formData
        }).then(res => {
          this.visible = false;
          this.$notice.success('操作成功');
          this.$emit('reload');
        });
      });
    },
    // 修改工号类型
    staffTypeChange() {
      this.formData.insuranceId2 = [];
      this.formData.insuranceId = '';
      this.getChannel();
    },
    // 获取合作渠道数据
    getChannel() {
      this.companyData = [];
      this.companyList = [];
      this.$http({
        url: this.formData.staffType == 1 ? '/buz/insuranceCompany/read/tree' : '/buz/insuranceChannel/read/tree',
        type: 'POST',
        data: {}
      }).then(res => {
        res.data.forEach(item => {
          if (item.sonInsurances && this.formData.staffType == 2) {
            item.children = item.sonInsurances;
          } else if (item.sonCompanys && this.formData.staffType == 1) {
            item.children = item.sonCompanys;
          }
          item.children &&
            item.children.forEach(item2 => {
              item2.label = item2.name;
              item2.value = item2.id;
              this.companyList.push(item2);
            });
          item.label = item.name;
          item.value = item.id;
          this.companyList.push(item);
        });
        this.companyData = res.data;
        // 处理回显数据
        if (this.formData.insuranceId) {
          const data = this.companyList.find(bean => {
            return bean.id == this.formData.insuranceId;
          });
          if (data) {
            if (data.parentId) {
              this.$set(this.formData, 'insuranceId2', [data.parentId, data.id]);
            } else {
              this.$set(this.formData, 'insuranceId2', [data.id]);
            }
          }
        }
      });
    },
    // 选择合作渠道
    cascaderChange(dataArr) {
      const data = dataArr.pop();
      console.log(data);
      this.$set(this.formData, 'insuranceId', data.id);
      this.$set(this.formData, 'insuranceName', data.name);
    },
    // 获取当前机构业务员
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {};
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else if (keyword.includes('-')) {
        return;
      } else {
        params.userName = keyword;
      }
      return this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 选择业务员
    async selectSalesMan(id) {
      const userList = this.$refs.salesmanSelect.list;
      const bean = userList.find(item => {
        return item.id == id;
      });
      if (bean) {
        this.$set(this.formData, 'groupName', bean.groupName);
        this.$set(this.formData, 'orgName', bean.organizationName);
      }
    }
  }
};
</script>
<style lang="scss" sopend >

</style>
<style lang="scss">
.ivu-cascader-transfer.big {
  .ivu-cascader-menu {
    min-width: 130px;
  }
}
</style>